import { ChangeDetectionStrategy, Component, Input, Optional, Self } from '@angular/core';
import { ControlContainer, FormGroupDirective, NgControl, ReactiveFormsModule } from '@angular/forms';
import { SliderModule } from 'primeng/slider';
import { AbstractControlToFormControlPipe } from '../../../pipes/abstract-control-to-form-control.pipe';

@Component({
  selector: 'shared-slider',
  imports: [SliderModule, ReactiveFormsModule, AbstractControlToFormControlPipe],
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class SliderComponent {
  @Input() range = false;
  @Input({ required: true }) min!: number;
  @Input({ required: true }) max!: number;
  @Input() step: number | null = null;

  constructor(@Self() @Optional() public ngControl: NgControl) {
    if (this.ngControl) {
      // trick it into thinking control has a valueAccessor, we don't need it because child has
      this.ngControl.valueAccessor = {
        writeValue(): void {
          // do nothing
        },
        registerOnChange(): void {
          // do nothing
        },
        registerOnTouched(): void {
          // do nothing
        },
      };
    }
  }

  getIntervalArray(): number[] {
    return Array.from(new Array(this.max - this.min), (x, i) => i);
  }
}
